import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styling/Invoice.css";
import { getInvoiceData } from "../Api/ViewPostedInvoice";
import { Base_URL } from "../url";
import { useReactToPrint } from "react-to-print";
const { ToWords } = require('to-words');

const toWords = new ToWords({
  localeCode: 'en-IN',    // Indian format
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: false
  }
});
const Invoice = () => {
  const location = useLocation();
  const componentRef = useRef();
  const toWords = new ToWords();

  const handlePrint = useReactToPrint({
    contentRef: componentRef, // ✅ new API for v3+
    documentTitle: "Invoice",
  });

  const invoiceId = location.pathname.split("/")[2];

  console.log(invoiceId, 'invoiceId')
  const [invoiceData, setInvoiceData] = useState({});
  const [count, setCount] = useState("");
  useEffect(() => {
    const fetchInvoiceData = async () => {
      const res = await getInvoiceData(invoiceId);
      console.log(res, 'res dngjf jhjkdt hjkt');
      setInvoiceData(res)
      setCount(res?.items?.length)
    }
    fetchInvoiceData()
  }, [])
  // Function to handle the download button click
  const handleDownload = async () => {
    try {
      // const response = await fetch("https://localhost:7039/api/InvoicePdf/DownloadSampleInvoice", {
      //   method: "GET",
      //   headers: {
      //     "Content-Type": "application/pdf",
      //   },
      // });
      const response = await fetch(`${Base_URL}/InvoicePdf/DownloadSampleInvoice?invoiceid=${invoiceId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
        },
      });

      console.log(response, 'response in file download')

      return
     {
      if (!response.ok) {
        throw new Error("Failed to download invoice");
      }

      // Convert the response to a blob
      const blob = await response.blob();

      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);
      //fasfaf
      // Create a temporary anchor element to trigger the download
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;

      // Extract filename from response headers or use a default
      const contentDisposition = response.headers.get("content-disposition");
      let fileName = "invoice.pdf";

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (fileNameMatch && fileNameMatch.length > 1) {
          fileName = fileNameMatch[1];
        }
      }

      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
} } catch (error) {
      console.error("Error downloading invoice:", error);
      alert("Failed to download invoice. Please try again.");
    }
  };
const totalGSTWords = toWords.convert(
  (Number(invoiceData?.invoiceSummary?.totalCGST || 0) +
   Number(invoiceData?.invoiceSummary?.totalSGST || 0) +
   Number(invoiceData?.invoiceSummary?.totalIGST || 0)),
  { currency: true }
).toUpperCase();
  console.log(invoiceData, 'invoiceData')

  return (
    <>
      {/* ===== Download Button Row ===== */}
      <div className="container-fluid">
        <div className="row mt-5 ">
          <div className="col-8 mt-5">
            {/* Empty space on left */}
          </div>
          <div className="col-4 text-end mt-5">
            <button
              className="btn btn-primary"
              // onClick={handleDownload}
              onClick={handlePrint}
            >
              Download Invoice
            </button>
          </div>
        </div>
      </div>
      <div ref={componentRef}>
        <div className="container invoice-container my-4 mx-4 p-2 border bg-white">
          <header>

            {/* <!-- Header --> */}
            {invoiceData?.invoice?.invoicePosted == 'Yes' ? <div className="invoice-header">
              TAX INVOICE
            </div> : <div className="invoice-header">
             {invoiceData.invoice} Pro-Forma Invoice
            </div>}

            {/* <!-- Company Section --> */}
            <div className="company-section">
              <div className="logo-section">
                <div className="logo">
                  <img src={invoiceData?.company?.logoUrl} className="img-fluid" />
                </div>
              </div>

              <div className="company-details">
                <div className="company-name">{invoiceData?.company?.name}</div>
                <div className="company-info">
                  {invoiceData?.office?.address1}<br />
                  {invoiceData?.office?.address2}<br />
                  {invoiceData?.office?.address3}<br />
                  {invoiceData?.city?.description} - {invoiceData?.office?.pincode}
                </div>
              </div>

              <div className="invoice-details">
                <div className="invoice-grid">
                  <ul className="invoice-lists">
                    <li>
                      <div className="invoice-item">
                        <span className="invoice-label">GSTIN NO.</span>
                        <span>{invoiceData?.office?.gstin}</span>
                      </div>
                    </li>
                    <li>
                      <div className="invoice-item">
                        <span className="invoice-label">STATE OF SALE.</span>
                        <span>{invoiceData?.city?.region}</span>
                      </div>
                    </li>
                    <li>
                      <div className="invoice-item">
                        <span className="invoice-label">CIN NO.</span>
                        <span>{invoiceData?.company?.cinNumber}</span>
                      </div>
                    </li>
                    <li>
                      <div className="invoice-item">
                        <span className="invoice-label">Company Code:</span>
                        <span>{invoiceData?.company?.companyCode}</span>
                      </div>
                    </li>
                    <li>
                      <div className="invoice-item">
                        <span className="invoice-label">Email.</span>
                        <span> {invoiceData?.office?.emailId}</span>
                      </div>
                    </li>
                  </ul>
                  <ul className="invoice-lists">
                    <li>
                      <div className="invoice-item">
                        <span className="invoice-label">INVOICE NO.</span>
                        <span>{invoiceData?.invoice?.invoicePosted == 'Yes' ? invoiceData?.invoice?.invoiceNumber : invoiceId}</span>
                      </div>
                    </li>
                    {/* <li>
                    <div className="invoice-item">
                      <span className="invoice-label">E-INVOICE ACK NO.</span>
                      <span>{invoiceData?.invoice?.einvIrn}</span>
                    </div>
                  </li> */}
                    <li>
                      <div className="invoice-item">
                        <span className="invoice-label">E-Way Bill No.</span>
                        <span>{invoiceData?.invoice?.ewayBillNumber}</span>
                      </div>
                    </li>
                    <li>
                      <div className="invoice-item">
                        <span className="invoice-label">DUE DATE</span>
                        <span>{invoiceData?.invoice?.dueDate?.split("T")[0]}</span>
                      </div>
                    </li>
                    <li>
                      <div className="invoice-item">
                        <span className="invoice-label">STORE TRN NO.</span>
                        <span>{invoiceData?.invoice?.storeTrn}</span>
                      </div>
                    </li>
                    <li>
                      <div className="invoice-item">
                        <span className="invoice-label">AGAINST ORDER NO.</span>
                        <span>{invoiceData?.invoice?.purchaseOrder}</span>
                      </div>
                    </li>
                  </ul>

                  <ul className="invoice-lists">
                    <li>
                      <div className="invoice-item">
                        <span className="invoice-label">Posting Date.</span>
                        <span>{invoiceData?.invoice?.invoiceDate
                          ? invoiceData.invoice.invoiceDate.split('T')[0].split('-').join('-')
                          : ''}</span>
                      </div>
                    </li>
                    {/* <li>
                    <div className="invoice-item">
                      <span className="invoice-label">E_INV DATE.</span>
                      <span>{invoiceData?.invoice?.einvDate?.split("T")[0]}</span>
                    </div>
                  </li> */}
                    <li>
                      <div className="invoice-item">
                        <span className="invoice-label">EWAY BILL DATE.</span>
                        <span>{invoiceData?.invoice?.ewaybDate?.split("T")[0]}</span>
                      </div>
                    </li>
                    <li>
                      <div className="invoice-item">
                        <span className="invoice-label">STORE TRN DATE.</span>
                        <span>{invoiceData?.invoice?.ewaybDate?.split("T")[0]}</span>
                      </div>
                    </li>

                    <li>
                      <div className="invoice-item">
                        <span className="invoice-label">CUST PO DATE.</span>
                        <span>{invoiceData?.invoice?.custpoDate?.split("T")[0]}</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* <!-- Customer and Delivery Section --> */}
            <div className="customer-section">
              <div className="customer-details">
                <div className="section-title">CUSTOMER DETAILS:</div>
                <div><b>{invoiceData?.customer?.name}</b></div>
                <br />
                <div>{invoiceData?.customer?.address1}, {invoiceData?.customer?.address2}<br />
                  {invoiceData?.customer?.address3} {invoiceData?.customer?.pinCode}</div>
                <div>{invoiceData?.region?.region}</div>
                <br />
                <div className="details-grid">
                  <span className="label">PLACE OF SUPPLY & STATE CODE</span>
                  <span>: {invoiceData?.region?.region}, {invoiceData?.region?.regionCode}</span>
                  <span className="label">GSTIN NO.</span>
                  <span>: {invoiceData?.customer?.gstno}</span>
                  <span className="label">PAN NO.</span>
                  <span>: {invoiceData?.customer?.pan}</span>
                </div>
              </div>

              <div className="delivery-details">
                <div className="section-title">ADDRESS OF DELIVERY</div>
                <div>{invoiceData?.shipping?.name}</div>
                <br />
                <div>{invoiceData?.shipping?.address1}, {invoiceData?.shipping?.address2}</div>

                <div>{invoiceData?.deliveryAdress?.description}</div>
                <div>{invoiceData?.shipping?.address3}</div>
                <div>GSTIN NO. : {invoiceData?.customer?.gstno}</div>
              </div>
              <div className="delivery-details">
                <div className="right-section">
                  <div className="right-item">
                    <span className="right-label">TYPE OF SALE</span>
                    <span>{invoiceData?.supply?.supplyTypeDescription}</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">DATE</span>
                    <span>{invoiceData?.invoice?.custpoDate?.split("T")[0]}</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">PLACE OF SALE</span>
                    <span>Intrastate</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">DATE</span>
                    <span>-</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">CUST. ORDER NO.</span>
                    <span>{invoiceData?.invoice?.purchaseOrder}</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">DATE</span>
                    <span>-</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">L.R. NO.</span>
                    <span>-</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">DATE</span>
                    <span>-</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">DISPATCH DATE</span>
                    <span>
                    </span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">CASES</span>
                    <span>0</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">TRANSPORTER NAME</span>
                    <span>-</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">TRANSPORT MODE</span>
                    <span>-</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">DESTINATION</span>
                    <span>-</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label"></span>
                    <span></span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">PAYMENT TERMS</span>
                    <span>-</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">VEHICLE NO.</span>
                    <span>-</span>
                  </div>
                </div>
              </div>
            </div>
          </header>


          {/* <!-- Products Table --> */}
          <table className="products-table">
            <thead>
              <tr>
                <th>SR. NO.</th>
                <th>PRODUCT DESCRIPTION</th>
                <th>HSN/SAC CODE</th>
                <th>Batch Number</th>
                {/* <th>Batch Qty.</th>
                <th>MRP</th> */}
                <th>Expiry Date</th>
                <th>QUANTITY</th>
                <th>UOM</th>
                <th>BILLING RATE</th>
                <th>BASIC VALUE</th>
                <th>DISC %</th>
                <th>DISCOUNT VALUE</th>
                <th>TAXABLE VALUE</th>
                <th colspan="2">IGST</th>
                <th colspan="2">CGST</th>
                <th colspan="2">SGST</th>
                <th>Gross Value</th>
              </tr>
              <tr>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                {/* <th></th>
                <th></th> */}
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th>RATE%</th>
                <th>AMOUNT</th>
                <th>RATE%</th>
                <th>AMOUNT</th>
                <th>RATE%</th>
                <th>AMOUNT</th>
                <th></th>

              </tr>
            </thead>
            <tbody>
              {invoiceData?.items?.length > 0 && invoiceData?.items.map((data, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{data?.itemName}</td>
                    <td>{data?.invoiceItem?.hsn}</td>
                    <td>{data?.invoiceItem?.batchId}</td>
                    {/* <td>NULL</td>
                    <td>NULL</td> */}
                    <td>{data?.expiryDate?.split("T")[0]}</td>
                    <td>{data?.invoiceItem?.quantity}</td>
                    <td>{data?.invoiceItem?.unitCode}</td>
                    <td>₹{data?.invoiceItem?.price}</td>
                    <td>
                      {`₹${(parseFloat(data?.invoiceItem?.price || 0) *
                        parseFloat(data?.invoiceItem?.quantity || 0)).toFixed(2)}`}
                    </td>
                    <td>{data?.invoiceItem?.discPercent}</td>
                    <td>₹{data?.invoiceItem?.discountValue}</td>
                    <td>₹{data?.invoiceItem?.taxableValue.toFixed(2)}</td>
                    {/* <td>{`₹${(parseFloat(data?.invoiceItem?.price || 0) *
                     parseFloat(data?.invoiceItem?.quantity || 0)).toFixed(2) - parseFloat(data?.invoiceItem?.discountValue)}`}</td> */}

                    <td>{data?.invoiceItem?.igst}</td>
                    <td>₹{parseFloat(data?.invoiceItem?.igstAmount)}</td>
                    <td>{data?.invoiceItem?.cgst}</td>
                    <td>{data?.invoiceItem?.cgstAmount}</td>
                    <td>{data?.invoiceItem?.sgst}</td>
                    <td>₹{parseFloat(data?.invoiceItem?.sgstAmount)}</td>

                    <td>₹{data?.invoiceItem?.grossValue.toFixed(2)}</td>

                  </tr>
                )
              })}
            </tbody>
          </table>

          {/* <!-- HSN Summary --> */}
          <div className="hsn-summary">
            <table className="hsn-table">
              <thead>
                <tr>
                  <th>HSN WISE SUMMARY</th>
                  <th>HSN CODE</th>
                  <th>TAXABLE VALUE</th>
                  <th>IGST RATE %</th>
                  <th>IGST AMOUNT</th>
                  <th>CGST RATE %</th>
                  <th>CGST AMOUNT</th>
                  <th>SGST/UT RATE %</th>
                  <th>SGST/UT AMOUNT</th>
                </tr>
              </thead>
              <tbody>

                {invoiceData?.groupedItems?.length > 0 && invoiceData?.groupedItems.map((data, index) => {
                  return (
                    <tr key={index}>
                      <td></td>
                      <td>{data?.hsnCode}</td>
                      <td>{data?.totalTaxableValue.toFixed(2)}</td>
                      <td>{data?.igstRate}</td>
                      <td>{data?.totalIGST}</td>
                      <td>{data?.cgstRate}</td>
                      <td>{data?.totalCGST}</td>
                      <td>{data?.sgstRate}</td>
                      <td>{data?.totalSGST}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>

          {/* <!-- Bottom Section --> */}
          <div className="bottom-section">
            <div className="payment-terms">
              {/* <div style={{ marginBottom: "10px" }}><strong>IRN NO. :</strong></div> */}

              <div className="total-words">
                <div><strong>TOTAL GST PAYABLE (IN WORDS) : {totalGSTWords}
                  {/* {toWords.convert(invoiceData?.invoiceSummary?.totalamount)} */}
                  {/* {toWords.convert(invoiceData?.invoiceSummary?.totalamount);} */}
                </strong></div>
                <br />
                <div><strong>TOTAL NET PAYABLE (IN WORDS) : {toWords.convert(Math.round(Number(invoiceData?.invoiceSummary?.totalamount ?? 0))).toUpperCase()} RUPEES AND ZERO PAISA ONLY</strong></div>
              </div>
            </div>

            <div className="amount-summary">
              <div className="amount-row">
                <div className="amount-label">TAXABLE AMOUNT</div>
                <div className="amount-value">{invoiceData?.invoiceSummary?.totalTaxableAmount}</div>
              </div>
              <div className="amount-row">
                <div className="amount-label">CGST AMOUNT</div>
                <div className="amount-value">{invoiceData?.invoiceSummary?.totalCGST}</div>
              </div>
              <div className="amount-row">
                <div className="amount-label">SGST/UT AMOUNT</div>
                <div className="amount-value">{invoiceData?.invoiceSummary?.totalSGST}</div>
              </div>
              <div className="amount-row">
                <div className="amount-label">IGST AMOUNT</div>
                <div className="amount-value">{invoiceData?.invoiceSummary?.totalIGST}</div>
              </div>
              <div className="amount-row">
                <div className="amount-label">TOTAL AMOUNT</div>
                <div className="amount-value">{invoiceData?.invoiceSummary?.totalamount}</div>
              </div>
              <div className="amount-row">
                <div className="amount-label">Rounding off</div>
                <div className="amount-value">{ (Math.round(Number(invoiceData?.invoiceSummary?.totalamount ?? 0))-invoiceData?.invoiceSummary?.totalamount).toFixed(2) }</div>
              </div>
              <div className="amount-row" style={{ background: "#f0f0f0" }}>
                <div className="amount-label">NET PAYABLE AMOUNT</div>
                <div className="amount-value" style={{ fontWeight: "bold" }}>{Math.round(Number(invoiceData?.invoiceSummary?.totalamount ?? 0))}</div>
              </div>
            </div>
          </div>


          {/* terms conetent start */}
          <div class="terms-container">
            {/* <!-- Terms Header --> */}
            <div class="terms-header">
              <div class="terms-title">TERMS & CONDITION :</div>
              <div class="company-name"> Siddhidhata Ayurved Private Limited</div>
            </div>

            {/* <!-- Terms Content --> */}
            <div class="terms-content">
              <ul class="terms-list">
                <li>(1) Goods once sold will not be taken back.</li>
                <li>(2) Goods are sold on an understanding that the buyer is holding all requisite valid Drug, Municipal and Tax.</li>
                <li>(3) Sold subject to our price list terms.</li>
                <li>(4) Interest @ 21% per annum will be applicable on payments made beyond due date.</li>
                <li>(5) The Company staffs are not allowed to take advance or money/stock transactions either in cash or in kind. Any claims in this regard will not be entertained.</li>
                <li>(6) I/WE hereby clarify that My / Our registration certificate under the S.T. Act 1959 is in force on the date on which the sales of the goods specified in this Bill/Cash Memorandum is made by me/us in the regular course of my/our business.</li>
              </ul>
            </div>

            {/* <!-- Signature Section --> */}
            <div class="signature-section">
              <div class="signature-box">
                <div class="signature-space"></div>
                {/* <div class="signature-label">E-Invoice Verification</div> */}
              </div>

              <div class="signature-box">
                <div class="signature-space"></div>
                {/* <div class="signature-label">E-Invoice Verifier</div> */}
              </div>

              <div class="signature-box">
                <div class="signature-space"></div>
                <div class="signature-label">AUTHORISED SIGNATORY</div>
              </div>
            </div>

            {/* terms conteent end */}

          </div>
        </div>
      </div>
    </>

  );
};

export default Invoice;